<template>
    <v-row class="gap" justify="center">
        <v-col cols="12" sm="8" md="8" lg="6">
            <div class="question">{{question}}{{required ? ' *' : ''}}</div>
            <v-radio-group class="radio-container" :value="answer" @change="inputAnswer" :rules="rules" hide-details row>
                <v-radio v-for="option in options" :key="option" color="#ea7f1d" :label="option" :value="option"></v-radio>
            </v-radio-group>
            <v-row v-for="(cq) in childQuestions" :key="cq.Id">
                <v-col class="extra-container" v-if="answer===cq.Extra_Option__c" cols="12">
                    <div class="question" style="font-size:14px">{{cq.Question_Text__c + (cq['Required__c'] ? ' *' : '')}}</div>
                    <v-text-field
                        :value="cq['Answer__c.Answer__c']"
                        @input="inputChildAnswer(cq, $event)"
                        multi-line
                        outlined
                        hide-details
                        :rules="cq['Required__c'] ? notEmpty : noRules"
                    ></v-text-field>
                    <!--
                    <v-text-field
                        :label="cq.Question_Text__c + (cq['Required__c'] ? ' *' : '')"
                        :value="cq['Answer__c.Answer__c']"
                        @input="inputChildAnswer(cq, $event)"
                        outlined
                        hide-details
                        :rules="cq['Required__c'] ? notEmpty : noRules"
                    ></v-text-field>
                    -->

                    <div v-if="cq['Helper_Text__c']" class="small-text sub-help-text" v-html="cq['Helper_Text__c']"></div>
                </v-col>
            </v-row>
            <div class="small-text" v-html="helper_text"></div>
        </v-col>
    </v-row>
</template>
<script>
// import axios from 'axios'
// import Client from '../client.js';

export default {
    props: {
       question: String,
       answer: String,
       options: Array,
       helper_text: String,
       extra_option: String,
       extras: Array,
       extra_answer: Array,
       required: Boolean,
       childQuestions: Array,
       qid: String,
    },
    computed: {
        rules() {
            return [() => {
                if(!this.required) return true;
                return Boolean(this.answer);
            }]
        },
        notEmpty() {
            return [v => {
                return Boolean(v) && v.trim().length > 0;
            }]
        },
        noRules() {
            return [() => true]
        }
    },
    methods: {
        inputAnswer(v) {
            this.$emit('on-answer', {qid: this.qid, answer: v});
        },
        inputChildAnswer(cq, v) {
            this.$emit('on-answer', {qid: cq.Id, answer: v});
        }
    },
    data: function() {
        return {
            toggle: null,
        }
    },
}
</script>
<style lang="scss" scoped>
.word-counts {
    margin-top: -20px;
    margin-bottom: 20px;
}
.small-text {
    font-family: $helper-font;
    font-size: 12px;
    line-height: 1.5;
}
.question {
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 1.25;
}
.gap {
    margin-bottom: 16px;
}
.checkbox-container {
    padding-top: 0;
    padding-bottom: 0;
}
.extra-container {
    padding-top: 0;
}
.radio-container {
    margin-bottom: 15px;
}
.sub-help-text {
    margin-top: 10px;
}
</style>
